module.exports = __webpack_public_path__ + "img/banner03.86ba81af.png";